import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import FeaturesHero from './components/FeaturesHero';
import JourneyFlow from './components/JourneyFlow';
import LeadCaptureModule from './components/LeadCaptureModule';
import WhatsAppAIModule from './components/WhatsAppAIModule';
import AIAssistantModule from './components/AIAssistantModule';
import ItineraryBuilderModule from './components/ItineraryBuilderModule';
import QuoteBuilderModule from './components/QuoteBuilderModule';
import PaymentConfirmationModule from './components/PaymentConfirmationModule';
import FollowupCRMModule from './components/FollowupCRMModule';
import FeaturesCTA from './components/FeaturesCTA';

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <main>
        <FeaturesHero />
        <JourneyFlow />
        <LeadCaptureModule />
        <WhatsAppAIModule />
        <AIAssistantModule />
        <ItineraryBuilderModule />
        <QuoteBuilderModule />
        <PaymentConfirmationModule />
        <FollowupCRMModule />
        <FeaturesCTA />
      </main>
      <Footer />
    </div>
  );
}
